// @flow

import Honeybadger from '@honeybadger-io/js';

export default function reportExtractionFailure(
  snapshotStack: Array<string>,
  json: mixed
): void {
  const error = new Error('Extraction error');

  if (__DEV__) {
    // Without the setTimeout, the console log can fail for some unknown reason
    /* eslint-disable no-alert, no-console */
    setTimeout(() => {
      console.group('Extraction error');
      console.error(snapshotStack.join('\n* '), { json });
      console.trace();
      console.groupEnd();
    }, 0);

    alert('Extraction error! Check console for more information');
    /* eslint-enable no-alert, no-console */
  } else {
    Honeybadger.notify(error, {
      message: snapshotStack.join(', '),
      context: { json }
    });
  }
}
